// Home2.jsx

import React from 'react';
import '../styles/Home/Home.scss';
import SlideShow from '../components-templates/Home/slideshow2';

const Home = () => {
  return (
    <div className="home">
      <SlideShow />
    </div>
  );
};

export default Home;
